<template>
  <div id="footer" class="d-flex align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 d-none d-md-flex align-items-center">
          <p class="m-0 text-white text-center text-md-left text-nowrap" v-html="copyright"></p>
        </div>
        <div class="col-12 col-md-6 d-flex align-items-center justify-content-end">
          <nav class="nav w-100 justify-content-center w-md-auto justify-content-md-end">
            <router-link :to="{ name: menu.path }" class="nav-link text-white" v-for="(menu, key) in menus" v-bind:key="key">{{ menu.name }}</router-link>
          </nav>
        </div>
        <div class="col-12 col-md-6 d-md-none">
          <p class="m-0 text-white text-center text-md-left text-nowrap" v-html="copyright"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KFooter',
  data () {
    return {
      lang: this.$router.history.current.params.lang,
      menus: [],
      copyright: '',
      year: new Date().getFullYear()
    }
  },
  created () {
    if (this.lang === 'th') {
      this.menus = [
        {
          name: 'หน้าแรก',
          path: 'Home'
        },
        {
          name: 'บริษัทผู้ผลิต',
          path: 'Manufacturer'
        },
        {
          name: 'ติดต่อเรา',
          path: 'Contact'
        }
      ]
      this.copyright = 'สงวนลิขสิทธิ์ &copy ' + (this.year + 543) + ' บริษัท เค ฟู๊ด อิมปอร์ต เอ็กซ์ปอร์ต  จำกัด'
    } else {
      this.menus = [
        {
          name: 'Home',
          path: 'Home'
        },
        {
          name: 'Manufacturer',
          path: 'Manufacturer'
        },
        {
          name: 'Contact',
          path: 'Contact'
        }
      ]
      this.copyright = 'Copyright &copy; ' + this.year + ' KFood Import Export Co., Ltd.'
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue